<template>
  <v-layout>
    <v-btn
      v-for="action in column.actions"
      :key="action.name"
      text
      @click="click(action.name)"
      class="mr-2 mt-1 mb-1"
      fab
      small
    >
      <v-icon v-if="action.icon">{{ action.icon }}</v-icon>
      <template v-if="action.text">{{ action.text }}</template>
    </v-btn>
  </v-layout>
</template>

<script>
import entities from "../../api/entities";

export default {
  name: "ActionsColumn",
  props: ["entity_type", "entity", "column", "value"],
  mounted() {
    console.log("TEST ACTIONS COLUMN");
  },
  methods: {
    async click(action_name) {
      const action = action_name;
      const result = await entities.action(
        this.token,
        this.entity_type,
        this.entity.id,
        action
      );
      const color = result.success ? "green" : "red";
      this.$root.$emit("notify", result.message || "Успешно", color);
      this.$root.$emit("reload_entities");
    }
  }
};
</script>

<style scoped></style>
